/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Ago", "azure-devops-ui/Card", "azure-devops-ui/Core/Observable", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Header", "azure-devops-ui/Link", "azure-devops-ui/Table", "azure-devops-ui/TooltipEx", "azure-devops-ui/Util", "azure-devops-ui/Utilities/Provider", "react", "../../Resources", "../Common/KubeCardWithTable", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/ActionsHubManager", "../KubeFactory", "../Selection/SelectionActionCreator", "../Selection/SelectionActions", "../Utils", "./PodsTable.scss"], function (require, exports, Ago_1, Card_1, Observable_1, String_1, Header_1, Link_1, Table_1, TooltipEx_1, Util_1, Provider_1, React, Resources, KubeCardWithTable_1, Constants_1, ActionsCreatorManager_1, ActionsHubManager_1, KubeFactory_1, SelectionActionCreator_1, SelectionActions_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var podNameKey = "pl-name-key";
    var podWorkloadsKey = "pl-wrkld-key";
    var podAgeKey = "pl-age-key";
    var RunningStatusKey = "running";
    var PodsTable = /** @class */ (function (_super) {
        __extends(PodsTable, _super);
        function PodsTable(props) {
            var _this = _super.call(this, props) || this;
            _this._showPodDetails = function (event, tableRow, selectedItem) {
                if (_this.props.onItemActivated) {
                    _this.props.onItemActivated(event, selectedItem);
                }
                else if (selectedItem) {
                    ActionsHubManager_1.ActionsHubManager.GetActionsHub(SelectionActions_1.SelectionActions).selectItem.invoke({
                        item: selectedItem,
                        itemUID: selectedItem.metadata.uid,
                        showSelectedItem: true,
                        selectedItemType: "orphan-pod" /* OrphanPodKey */
                    });
                }
            };
            _this._isTTIMarked = false;
            _this._statusCount = {};
            if (!_this.props.markTTICallback) {
                KubeFactory_1.getTelemetryService().scenarioStart(Constants_1.Scenarios.PodsList);
            }
            return _this;
        }
        PodsTable.prototype.render = function () {
            var _this = this;
            var showWorkloadColumn = this.props.showWorkloadColumn || false;
            var filteredPods = (this.props.podsToRender || []).filter(function (pod) {
                return Utils_1.Utils.filterByName(pod.metadata.name, _this.props.nameFilter);
            });
            if (filteredPods.length > 0) {
                this._prepareSubTextData(filteredPods);
                var tableProps = {
                    id: "pods-table",
                    showHeader: true,
                    showLines: true,
                    singleClickActivation: true,
                    itemProvider: new Provider_1.ArrayItemProvider(filteredPods),
                    ariaLabel: this.props.headingText,
                    columns: PodsTable._getColumns(showWorkloadColumn),
                    onActivate: function (event, tableRow) {
                        _this._showPodDetails(event, tableRow, filteredPods[tableRow.index]);
                    }
                };
                return (React.createElement(Card_1.CustomCard, { className: "pods-associated k8s-card-padding flex-grow bolt-table-card bolt-card-no-vertical-padding" },
                    React.createElement(Header_1.CustomHeader, null,
                        React.createElement(Header_1.HeaderTitleArea, null,
                            React.createElement(Header_1.HeaderTitleRow, null,
                                React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */ }, this.props.headingText)),
                            React.createElement(Header_1.HeaderDescription, { className: "text-ellipsis" }, this._generateHeadingSubText(this._statusCount)))),
                    React.createElement(Card_1.CardContent, { className: Util_1.css(this.props.contentClassName || "", "pod-associated-table"), contentPadding: false },
                        React.createElement(Table_1.Table, __assign({}, tableProps)))));
            }
            return null;
        };
        PodsTable.prototype.componentDidMount = function () {
            if (!this.props.markTTICallback) {
                KubeFactory_1.getTelemetryService().scenarioEnd(Constants_1.Scenarios.PodsList);
            }
        };
        PodsTable.prototype._prepareSubTextData = function (filteredPods) {
            var _this = this;
            this._statusCount = {};
            filteredPods.forEach(function (pod) {
                var key = pod.status.message ? pod.status.reason : pod.status.phase;
                if (key in _this._statusCount) {
                    _this._statusCount[key] += 1;
                }
                else {
                    _this._statusCount[key] = 1;
                }
            });
        };
        PodsTable._getColumns = function (showWorkloadColumn) {
            var columns = [];
            columns.push({
                id: podNameKey,
                name: Resources.PodsDetailsText,
                width: showWorkloadColumn ? -58 : new Observable_1.ObservableValue(362),
                renderCell: PodsTable._renderPodNameCell
            });
            if (showWorkloadColumn) {
                columns.push({
                    id: podWorkloadsKey,
                    name: Resources.WorkloadText,
                    width: -24,
                    renderCell: PodsTable._renderPodWorkload
                });
            }
            columns.push({
                id: "podStatus",
                name: Resources.StatusText,
                width: new Observable_1.ObservableValue(showWorkloadColumn ? 220 : 256),
                renderCell: function (rowIndex, columnIndex, tableColumn, pod) {
                    var textToRender = pod.status.message ? pod.status.reason : pod.status.phase;
                    return Table_1.renderSimpleCell(rowIndex, columnIndex, tableColumn, { "podStatus": textToRender });
                }
            });
            columns.push({
                id: podAgeKey,
                name: Resources.AgeText,
                width: showWorkloadColumn ? -18 : -100,
                renderCell: PodsTable._renderPodAgeCell
            });
            return columns;
        };
        PodsTable._renderPodNameCell = function (rowIndex, columnIndex, tableColumn, pod) {
            var _a = Utils_1.Utils.generatePodStatusProps(pod.status), statusProps = _a.statusProps, tooltip = _a.tooltip;
            return KubeCardWithTable_1.renderPodNameWithStatusTableCell(rowIndex, columnIndex, tableColumn, pod.metadata.name, statusProps, tooltip, "body-m font-weight-semibold");
        };
        PodsTable._renderPodWorkload = function (rowIndex, columnIndex, tableColumn, pod) {
            var textToRender = pod.metadata && pod.metadata.ownerReferences && pod.metadata.ownerReferences.length > 0 ? pod.metadata.ownerReferences[0].name || "" : "";
            var controllerOwner = pod.metadata.ownerReferences && pod.metadata.ownerReferences.find(function (o) { return !!o.controller; });
            var itemToRender = textToRender.length > 0 ? (React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true }, controllerOwner ?
                (React.createElement(Link_1.Link, { className: "fontSizeM font-size-m text-ellipsis bolt-table-link", rel: "noopener noreferrer", excludeTabStop: true, onClick: function (e) {
                        e.preventDefault();
                        PodsTable._onWorkloadClicked(pod, controllerOwner);
                    } }, textToRender))
                : textToRender)) : null;
            return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender, undefined, textToRender && controllerOwner ? "bolt-table-cell-content-with-link" : "");
        };
        PodsTable._renderPodAgeCell = function (rowIndex, columnIndex, tableColumn, pod) {
            var itemToRender = pod.status && pod.status.startTime
                ? React.createElement(Ago_1.Ago, { className: "body-m", date: new Date(pod.status.startTime), format: 1 /* Extended */ })
                : null;
            return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
        };
        PodsTable.prototype._generateHeadingSubText = function (podStatuses) {
            var keys = Object.keys(podStatuses);
            var subText = "";
            var runningIndex = keys.indexOf(RunningStatusKey);
            if (runningIndex >= 0) {
                subText = String_1.localeFormat("{0} {1}", podStatuses[RunningStatusKey], RunningStatusKey);
                keys.splice(runningIndex, 1);
            }
            keys.forEach(function (key) {
                var suffix = subText ? String_1.localeFormat(" · {0}", subText) : "";
                subText = String_1.localeFormat("{0} {1}{2}", podStatuses[key], key, suffix);
            });
            return subText;
        };
        PodsTable._onWorkloadClicked = function (pod, controllerOwner) {
            var type = "replica-set" /* ReplicaSetKey */;
            switch (controllerOwner.kind) {
                case "DaemonSet":
                    type = "daemon-set" /* DaemonSetKey */;
                    break;
                case "StatefulSet":
                    type = "stateful-set" /* StatefulSetKey */;
                    break;
            }
            var payload = {
                item: undefined,
                itemUID: controllerOwner.uid,
                showSelectedItem: true,
                selectedItemType: type
            };
            ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(SelectionActionCreator_1.SelectionActionsCreator).selectItem(payload);
        };
        return PodsTable;
    }(React.Component));
    exports.PodsTable = PodsTable;
});
